import React from "react";

const Card = ({ img, title, subtitle, description, navigateToAssignment }) => {
  return (
    <div className="w-[300px]">
      <div className="bg-white rounded-lg shadow-md">
        <img
          src={img}
          alt="Assignment"
          className="w-full h-32 object-cover rounded-t-lg mb-2"
        />
        <div className="p-2">
          <h5 className="text-[#67748E] text-[14px] font-Nunito">{subtitle}</h5>
          <h4 className="text-[20px] text-[#141414] font-Nunito font-bold mb-2">
            {title}
          </h4>
          <p className="text-[14px] text-[#67748E]">{description}</p>
          <button
            onClick={navigateToAssignment}
            className="py-3 px-4 bg-transparent text-[14px] text-[#5002D0] rounded-lg my-4 w-[200px] border-2 border-[#5002D0] font-Nunito font-semibold"
          >
            View Assignment
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
